WiseMetering.Views.DestroyObjective = WiseMetering.Views.Modal.Destroy.extend({
    title: () => i18next.t('modal.title.objectives.destroy')
});
